var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:[
      _vm.isPrimary
        ? 'btn-red-white btn-100--red'
        : 'btn-red-white btn-100--white',
    ],attrs:{"type":"button"},on:{"click":() => _vm.$emit('onClick')}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }